/**
 * The signed-out screen.
 *
 * A separate component only because the shell returns early for it: when
 * there is no signed-in account this is the whole view. Its markup carries the
 * `.background` / `.login-card` class names that App.scss styles.
 */
export function LoginScreen({ onLogin }: { onLogin: () => void }) {
  return (
    <div>
      <div className="background">
        <div className="login-in-image">
          <div className="login-card">
            <img
              className="login-card__logo"
              src="/assets/images/brand/cw-logo-indigo.png"
              alt="Cushman &amp; Wakefield"
              width={1024}
              height={215}
            />
            <p className="login-card__tagline">Better never settles</p>
            <span className="login-card__rule" />
            <h1 className="login-card__title">Valuation &amp; Advisory</h1>
            <p className="login-card__subtitle">
              Sign in with your Cushman &amp; Wakefield account to continue.
            </p>
            <button className="login-button" onClick={onLogin}>
              Login as Internal user
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginScreen;
